import styled from 'styled-components';

export const TankCleaningWrapper = styled.div``;
